import Vue from 'vue';
import {formatLocal} from '@/utils/dates';


Vue.mixin({
  methods: {
    formatTime(d) {
      return formatLocal(d, this.$store.getters['config/timeFormat']);
    }
  }
});
